var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "popular-apps-container" }, [
    _vm.isPopularAppsLoading
      ? _c("div", [_c("generic-loading-skeleton")], 1)
      : _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _vm.isLoadingError
            ? _c("div", { staticClass: "alert alert-error" }, [
                _vm._v(_vm._s(_vm.errorMsg))
              ])
            : _c(
                "div",
                _vm._l(_vm.popularApps, function(app) {
                  return _c(
                    "div",
                    {
                      key: app.id,
                      staticClass: "mr-2 popular-apps-card pb-16-px pl-1"
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: app.url,
                            target: _vm.getLinkTarget(app)
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "popular-apps-image",
                            attrs: { src: app.image },
                            on: {
                              click: function($event) {
                                return _vm.navigateToApp(app)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "popular-app-title ml-1 align-middle",
                              on: {
                                click: function($event) {
                                  return _vm.navigateToApp(app)
                                }
                              }
                            },
                            [_vm._v(_vm._s(app.title))]
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pb-2" }, [
      _c("h2", [_vm._v("Popular links")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-703ee108", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703ee108","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/PopularApps.vue
// module id = null
// module chunks = 